export const SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'reviews-text'

export const REVIEWS_LIST_ID = {
  DESKTOP: 'reviews-list',
  MOBILE: 'reviews-list-mobile',
}

export const TRACKING_ZONE = 'reviews'
